

// // src/pages/user/Home.jsx
// // src/pages/user/Home.jsx
// import React, { useState, useEffect } from 'react';
// import HeroSection from '../../components/user/HeroSection';
// import ServiceCard from '../../components/user/ServiceCard';
// import ProjectCard from '../../components/user/ProjectCard';
// import CertificationBadge from '../../components/user/CertificationBadge';
// import ZambiaAuthorities from '../../components/user/ZambiaAuthorities';
// // CHANGE BACK to getCertifications if getFeaturedCertifications doesn't exist yet
// import { getServices, getProjects, getCertifications } from '../../utils/api';
// import { COMPANY_INFO } from '../../utils/constants';
// import { FaAward, FaUsers, FaHandshake, FaShieldAlt } from 'react-icons/fa';

// const Home = () => {
//   const [services, setServices] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [certifications, setCertifications] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadData();
//   }, []);

//   const loadData = async () => {
//     try {
//       // Use individual try-catch for each API call to prevent one from breaking all
//       let servicesData, projectsData, certsData;
      
//       // Load services
//       try {
//         servicesData = await getServices();
//         console.log('Services data:', servicesData);
//       } catch (error) {
//         console.error('Error loading services:', error);
//         servicesData = [];
//       }
      
//       // Load projects
//       try {
//         projectsData = await getProjects();
//         console.log('Projects data:', projectsData);
//       } catch (error) {
//         console.error('Error loading projects:', error);
//         projectsData = [];
//       }
      
//       // Load certifications - CHANGE BACK to getCertifications for now
//       try {
//         certsData = await getCertifications(); // Use regular getCertifications
//         console.log('Certifications data:', certsData);
//       } catch (error) {
//         console.error('Error loading certifications:', error);
//         certsData = [];
//       }
      
//       // Handle different response structures
//       let servicesArray = [];
//       let projectsArray = [];
//       let certsArray = [];
      
//       // Process services data
//       if (Array.isArray(servicesData)) {
//         servicesArray = servicesData;
//       } else if (servicesData && servicesData.data && Array.isArray(servicesData.data.data)) {
//         servicesArray = servicesData.data.data;
//       } else if (servicesData && servicesData.data && Array.isArray(servicesData.data)) {
//         servicesArray = servicesData.data;
//       }
      
//       // Process projects data
//       if (Array.isArray(projectsData)) {
//         projectsArray = projectsData;
//       } else if (projectsData && projectsData.data && Array.isArray(projectsData.data.data)) {
//         projectsArray = projectsData.data.data;
//       } else if (projectsData && projectsData.data && Array.isArray(projectsData.data)) {
//         projectsArray = projectsData.data;
//       }
      
//       // Process certifications data
//       if (Array.isArray(certsData)) {
//         certsArray = certsData;
//       } else if (certsData && certsData.data && Array.isArray(certsData.data.data)) {
//         certsArray = certsData.data.data;
//       } else if (certsData && certsData.data && Array.isArray(certsData.data)) {
//         certsArray = certsData.data;
//       }
      
//       // Filter only active services (for user-facing pages)
//       const activeServices = servicesArray.filter(service => 
//         service.is_active !== false
//       );
      
//       // Filter only active projects
//       const activeProjects = projectsArray.filter(project => 
//         project.is_active !== false
//       );
      
//       // Filter only active certifications
//       const activeCertifications = certsArray.filter(cert => 
//         cert.is_active !== false
//       );
      
//       // Sort certifications with Zambia authorities first
//       const sortedCerts = [...activeCertifications].sort((a, b) => {
//         // Zambia authorities first
//         const zambiaAuths = ['PACRA', 'ZRA', 'ZPPA', 'NCC', 'WCFCB', 'NAPSA'];
//         const aAuthority = a.authority_acronym || a.issuing_authority;
//         const bAuthority = b.authority_acronym || b.issuing_authority;
//         const aIsZambia = zambiaAuths.includes(aAuthority);
//         const bIsZambia = zambiaAuths.includes(bAuthority);
        
//         if (aIsZambia && !bIsZambia) return -1;
//         if (!aIsZambia && bIsZambia) return 1;
        
//         // Then by display order
//         return (a.display_order || 0) - (b.display_order || 0);
//       });
      
//       // Store all active services in sessionStorage for ServiceDetail page
//       try {
//         sessionStorage.setItem('allServices', JSON.stringify(activeServices));
//       } catch (error) {
//         console.log('Could not store services in sessionStorage:', error);
//       }
      
//       setServices(activeServices.slice(0, 6));
//       setProjects(activeProjects.slice(0, 4));
//       setCertifications(sortedCerts.slice(0, 6));
      
//     } catch (error) {
//       console.error('Error loading data:', error);
//       // Set empty arrays on error
//       setServices([]);
//       setProjects([]);
//       setCertifications([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
//         <p className="text-gray-600">Loading content...</p>
//       </div>
//     );
//   }

//   return (
//     <div>
//       {/* Hero Section */}
//       <HeroSection />

//       {/* Services Preview */}
//       <section className="section-padding bg-gray-50">
//         <div className="container-custom">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Services</h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               Comprehensive engineering solutions across multiple sectors
//             </p>
//           </div>
          
//           {services.length === 0 ? (
//             <div className="text-center py-12">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
//                 <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                 </svg>
//               </div>
//               <p className="text-gray-500 text-lg">No services available at the moment.</p>
//               <p className="text-gray-400 mt-2">Please check back later.</p>
//             </div>
//           ) : (
//             <>
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                 {services.map(service => (
//                   <ServiceCard key={service.id} service={service} />
//                 ))}
//               </div>
              
//               {services.length >= 6 && (
//                 <div className="text-center mt-12">
//                   <a
//                     href="/services"
//                     className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold text-lg"
//                   >
//                     View All Services
//                     <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
//                     </svg>
//                   </a>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </section>

//       {/* Core Values */}
//       <section className="section-padding bg-white">
//         <div className="container-custom">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Core Values</h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               The principles that guide our work and define our company culture
//             </p>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//             <div className="text-center p-6">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
//                 <FaShieldAlt className="h-8 w-8 text-blue-600" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-3">Honesty & Integrity</h3>
//               <p className="text-gray-600">
//                 Upholding the highest ethical standards in all our business dealings
//               </p>
//             </div>
            
//             <div className="text-center p-6">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6">
//                 <FaUsers className="h-8 w-8 text-green-600" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-3">Customer Service</h3>
//               <p className="text-gray-600">
//                 Building lasting relationships through quality service and support
//               </p>
//             </div>
            
//             <div className="text-center p-6">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-6">
//                 <FaAward className="h-8 w-8 text-purple-600" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-3">Quality</h3>
//               <p className="text-gray-600">
//                 Delivering safe, effective products and reliable services
//               </p>
//             </div>
            
//             <div className="text-center p-6">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-6">
//                 <FaHandshake className="h-8 w-8 text-orange-600" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-3">Teamwork</h3>
//               <p className="text-gray-600">
//                 Collaborating across disciplines to achieve excellence
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Projects Showcase */}
//       <section className="section-padding bg-gray-50">
//         <div className="container-custom">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-gray-800 mb-4">Recent Projects</h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               Showcasing our engineering expertise and successful implementations
//             </p>
//           </div>
          
//           {projects.length === 0 ? (
//             <div className="text-center py-12">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
//                 <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
//                 </svg>
//               </div>
//               <p className="text-gray-500 text-lg">No projects to display at the moment.</p>
//             </div>
//           ) : (
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               {projects.map(project => (
//                 <ProjectCard key={project.id} project={project} />
//               ))}
//             </div>
//           )}
//         </div>
//       </section>

//       {/* NEW: Zambia Regulatory Authorities Section */}
//       <ZambiaAuthorities certifications={certifications} />

//       {/* Certifications */}
//       <section className="section-padding bg-white">
//         <div className="container-custom">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-gray-800 mb-4">Official Certifications & Accreditations</h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               Certified and registered with Zambian regulatory authorities and industry bodies
//             </p>
//           </div>
          
//           {certifications.length === 0 ? (
//             <div className="text-center py-12">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
//                 <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
//                 </svg>
//               </div>
//               <p className="text-gray-500 text-lg">Certifications information will be available soon.</p>
//             </div>
//           ) : (
//             <>
//               <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
//                 {certifications.map(cert => (
//                   <CertificationBadge key={cert.id} certification={cert} />
//                 ))}
//               </div>
              
//               {/* NEW: View All Certifications Button */}
//               {certifications.length >= 3 && (
//                 <div className="text-center mt-12">
//                   <a
//                     href="/certifications"
//                     className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl"
//                   >
//                     View All Certifications
//                     <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
//                     </svg>
//                   </a>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="bg-gradient-to-r from-blue-600 to-blue-800 py-20">
//         <div className="container-custom text-center">
//           <h2 className="text-4xl font-bold text-white mb-6">
//             Ready to Start Your Project?
//           </h2>
//           <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
//             Contact us today for a consultation and let's build something great together.
//           </p>
//           <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <a
//               href="/contact"
//               className="inline-flex items-center justify-center bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200"
//             >
//               Get In Touch
//               <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
//               </svg>
//             </a>
//             <a
//               href="/services"
//               className="inline-flex items-center justify-center bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors duration-200"
//             >
//               View Our Services
//               <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//               </svg>
//             </a>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Home;


// src/pages/user/Home.jsx
// import React, { useState, useEffect } from 'react';
// import HeroSection from '../../components/user/HeroSection';
// import ServiceCard from '../../components/user/ServiceCard';
// import ProjectCard from '../../components/user/ProjectCard';
// import ZambiaAuthorities from '../../components/user/ZambiaAuthorities';
// import { getServices, getProjects, getCertifications } from '../../utils/api';
// import { COMPANY_INFO } from '../../utils/constants';
// import { FaAward, FaUsers, FaHandshake, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';

// const Home = () => {
//   const [services, setServices] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadData();
//   }, []);

//   const loadData = async () => {
//     try {
//       let servicesData, projectsData;
      
//       // Load services
//       try {
//         servicesData = await getServices();
//         console.log('Services data:', servicesData);
//       } catch (error) {
//         console.error('Error loading services:', error);
//         servicesData = [];
//       }
      
//       // Load projects
//       try {
//         projectsData = await getProjects();
//         console.log('Projects data:', projectsData);
//       } catch (error) {
//         console.error('Error loading projects:', error);
//         projectsData = [];
//       }
      
//       // Handle different response structures
//       let servicesArray = [];
//       let projectsArray = [];
      
//       // Process services data
//       if (Array.isArray(servicesData)) {
//         servicesArray = servicesData;
//       } else if (servicesData && servicesData.data && Array.isArray(servicesData.data.data)) {
//         servicesArray = servicesData.data.data;
//       } else if (servicesData && servicesData.data && Array.isArray(servicesData.data)) {
//         servicesArray = servicesData.data;
//       }
      
//       // Process projects data
//       if (Array.isArray(projectsData)) {
//         projectsArray = projectsData;
//       } else if (projectsData && projectsData.data && Array.isArray(projectsData.data.data)) {
//         projectsArray = projectsData.data.data;
//       } else if (projectsData && projectsData.data && Array.isArray(projectsData.data)) {
//         projectsArray = projectsData.data;
//       }
      
//       // Filter only active services (for user-facing pages)
//       const activeServices = servicesArray.filter(service => 
//         service.is_active !== false
//       );
      
//       // Filter only active projects
//       const activeProjects = projectsArray.filter(project => 
//         project.is_active !== false
//       );
      
//       // Store all active services in sessionStorage for ServiceDetail page
//       try {
//         sessionStorage.setItem('allServices', JSON.stringify(activeServices));
//       } catch (error) {
//         console.log('Could not store services in sessionStorage:', error);
//       }
      
//       setServices(activeServices.slice(0, 6));
//       setProjects(activeProjects.slice(0, 4));
      
//     } catch (error) {
//       console.error('Error loading data:', error);
//       // Set empty arrays on error
//       setServices([]);
//       setProjects([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
//         <p className="text-gray-600">Loading content...</p>
//       </div>
//     );
//   }

//   return (
//     <div>
//       {/* Hero Section */}
//       <HeroSection />

//       {/* Services Preview */}
//       <section className="section-padding bg-gray-50">
//         <div className="container-custom">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Services</h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               Comprehensive engineering solutions across multiple sectors
//             </p>
//           </div>
          
//           {services.length === 0 ? (
//             <div className="text-center py-12">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
//                 <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                 </svg>
//               </div>
//               <p className="text-gray-500 text-lg">No services available at the moment.</p>
//               <p className="text-gray-400 mt-2">Please check back later.</p>
//             </div>
//           ) : (
//             <>
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                 {services.map(service => (
//                   <ServiceCard key={service.id} service={service} />
//                 ))}
//               </div>
              
//               {services.length >= 6 && (
//                 <div className="text-center mt-12">
//                   <a
//                     href="/services"
//                     className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold text-lg"
//                   >
//                     View All Services
//                     <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
//                     </svg>
//                   </a>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </section>

//       {/* Core Values */}
//       <section className="section-padding bg-white">
//         <div className="container-custom">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Core Values</h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               The principles that guide our work and define our company culture
//             </p>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//             <div className="text-center p-6">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
//                 <FaShieldAlt className="h-8 w-8 text-blue-600" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-3">Honesty & Integrity</h3>
//               <p className="text-gray-600">
//                 Upholding the highest ethical standards in all our business dealings
//               </p>
//             </div>
            
//             <div className="text-center p-6">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6">
//                 <FaUsers className="h-8 w-8 text-green-600" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-3">Customer Service</h3>
//               <p className="text-gray-600">
//                 Building lasting relationships through quality service and support
//               </p>
//             </div>
            
//             <div className="text-center p-6">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-6">
//                 <FaAward className="h-8 w-8 text-purple-600" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-3">Quality</h3>
//               <p className="text-gray-600">
//                 Delivering safe, effective products and reliable services
//               </p>
//             </div>
            
//             <div className="text-center p-6">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-6">
//                 <FaHandshake className="h-8 w-8 text-orange-600" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-3">Teamwork</h3>
//               <p className="text-gray-600">
//                 Collaborating across disciplines to achieve excellence
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Projects Showcase */}
//       <section className="section-padding bg-gray-50">
//         <div className="container-custom">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-gray-800 mb-4">Recent Projects</h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               Showcasing our engineering expertise and successful implementations
//             </p>
//           </div>
          
//           {projects.length === 0 ? (
//             <div className="text-center py-12">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
//                 <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
//                 </svg>
//               </div>
//               <p className="text-gray-500 text-lg">No projects to display at the moment.</p>
//             </div>
//           ) : (
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               {projects.map(project => (
//                 <ProjectCard key={project.id} project={project} />
//               ))}
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Zambia Regulatory Authorities Section */}
//       <ZambiaAuthorities />

//       {/* Certifications - SIMPLIFIED VERSION */}
//       <section className="section-padding bg-white">
//         <div className="container-custom">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-gray-800 mb-4">Certifications & Compliance</h2>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               Fully compliant with all Zambian regulatory authorities and industry standards
//             </p>
//           </div>
          
//           <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 border border-blue-200">
//             <div className="max-w-4xl mx-auto text-center">
//               <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-600 to-blue-800 rounded-full mb-6 shadow-lg">
//                 <FaCheckCircle className="h-8 w-8 text-white" />
//               </div>
//               <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
//                 Registered & Certified in Zambia
//               </h3>
//               <p className="text-lg text-gray-700 mb-6">
//                 Brasotech Investments Limited maintains full compliance with all Zambian regulatory authorities 
//                 and government agencies. We operate in accordance with the highest standards of business practice 
//                 and legal requirements.
//               </p>
//               <div className="flex flex-col sm:flex-row gap-4 justify-center">
//                 <a 
//                   href="/certifications" 
//                   className="inline-flex items-center justify-center bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
//                 >
//                   Learn About Our Compliance
//                 </a>
//                 <a 
//                   href="/contact" 
//                   className="inline-flex items-center justify-center bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold border border-blue-600 hover:bg-blue-50 transition-colors"
//                 >
//                   Request Verification
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="bg-gradient-to-r from-blue-600 to-blue-800 py-20">
//         <div className="container-custom text-center">
//           <h2 className="text-4xl font-bold text-white mb-6">
//             Ready to Start Your Project?
//           </h2>
//           <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
//             Contact us today for a consultation and let's build something great together.
//           </p>
//           <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <a
//               href="/contact"
//               className="inline-flex items-center justify-center bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200"
//             >
//               Get In Touch
//               <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
//               </svg>
//             </a>
//             <a
//               href="/services"
//               className="inline-flex items-center justify-center bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors duration-200"
//             >
//               View Our Services
//               <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//               </svg>
//             </a>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Home;

import React, { useState, useEffect, useRef } from 'react';
import HeroSection from '../../components/user/HeroSection';
import ServiceCard from '../../components/user/ServiceCard';
import ProjectCard from '../../components/user/ProjectCard';
import ZambiaAuthorities from '../../components/user/ZambiaAuthorities';
import { getServices, getProjects, getCertifications } from '../../utils/api';
import { COMPANY_INFO } from '../../utils/constants';
import { 
  FaAward, 
  FaUsers, 
  FaHandshake, 
  FaShieldAlt, 
  FaCheckCircle,
  FaChevronLeft,
  FaChevronRight,
  FaPlay,
  FaPause
} from 'react-icons/fa';

const ServiceImageSlider = ({ services }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentServiceIndex, setCurrentServiceIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [showDescription, setShowDescription] = useState(true);
  const intervalRef = useRef(null);
  const descriptionTimeoutRef = useRef(null);

  // Filter services that have images
  const servicesWithImages = services.filter(service => 
    service.image_url || 
    (service.details && service.details.additionalImages && service.details.additionalImages.length > 0)
  );

  // Get all images from current service
  const getCurrentServiceImages = () => {
    if (servicesWithImages.length === 0) return [];
    
    const currentService = servicesWithImages[currentServiceIndex];
    const images = [];
    
    // Add main image
    if (currentService.image_url) {
      images.push({
        url: currentService.image_url,
        description: currentService.title,
        serviceTitle: currentService.title,
        isMain: true
      });
    }
    
    // Add additional images
    if (currentService.details) {
      let details = currentService.details;
      if (typeof details === 'string') {
        try {
          details = JSON.parse(details);
        } catch (e) {
          details = { additionalImages: [] };
        }
      }
      
      if (details.additionalImages && Array.isArray(details.additionalImages)) {
        details.additionalImages.forEach(img => {
          if (img.url) {
            images.push({
              url: img.url,
              description: img.subtitle || img.description || currentService.title,
              serviceTitle: currentService.title,
              isMain: false
            });
          }
        });
      }
    }
    
    return images;
  };

  const images = getCurrentServiceImages();

  // Start/stop autoplay
  const startAutoplay = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    
    intervalRef.current = setInterval(() => {
      setCurrentSlide(prev => {
        const nextSlide = prev + 1;
        const totalSlides = images.length;
        
        if (nextSlide >= totalSlides) {
          // Move to next service
          const nextServiceIndex = (currentServiceIndex + 1) % servicesWithImages.length;
          setCurrentServiceIndex(nextServiceIndex);
          return 0;
        }
        return nextSlide;
      });
      
      // Show description for 3 seconds, then hide for 2 seconds
      setShowDescription(true);
      if (descriptionTimeoutRef.current) clearTimeout(descriptionTimeoutRef.current);
      descriptionTimeoutRef.current = setTimeout(() => {
        setShowDescription(false);
      }, 3000);
    }, 5000); // Change slide every 5 seconds
  };

  const stopAutoplay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (descriptionTimeoutRef.current) {
      clearTimeout(descriptionTimeoutRef.current);
      descriptionTimeoutRef.current = null;
    }
  };

  useEffect(() => {
    if (isPlaying && images.length > 0) {
      startAutoplay();
    } else {
      stopAutoplay();
    }
    
    return () => {
      stopAutoplay();
    };
  }, [isPlaying, currentServiceIndex, images.length]);

  const nextSlide = () => {
    stopAutoplay();
    setCurrentSlide(prev => {
      const nextSlide = prev + 1;
      if (nextSlide >= images.length) {
        const nextServiceIndex = (currentServiceIndex + 1) % servicesWithImages.length;
        setCurrentServiceIndex(nextServiceIndex);
        return 0;
      }
      return nextSlide;
    });
    setShowDescription(true);
    if (descriptionTimeoutRef.current) clearTimeout(descriptionTimeoutRef.current);
    descriptionTimeoutRef.current = setTimeout(() => {
      setShowDescription(false);
    }, 3000);
  };

  const prevSlide = () => {
    stopAutoplay();
    setCurrentSlide(prev => {
      const prevSlide = prev - 1;
      if (prevSlide < 0) {
        const prevServiceIndex = currentServiceIndex === 0 
          ? servicesWithImages.length - 1 
          : currentServiceIndex - 1;
        setCurrentServiceIndex(prevServiceIndex);
        const newImages = getCurrentServiceImages();
        return newImages.length - 1;
      }
      return prevSlide;
    });
    setShowDescription(true);
    if (descriptionTimeoutRef.current) clearTimeout(descriptionTimeoutRef.current);
    descriptionTimeoutRef.current = setTimeout(() => {
      setShowDescription(false);
    }, 3000);
  };

  const goToService = (index) => {
    stopAutoplay();
    setCurrentServiceIndex(index);
    setCurrentSlide(0);
    setShowDescription(true);
    if (descriptionTimeoutRef.current) clearTimeout(descriptionTimeoutRef.current);
    descriptionTimeoutRef.current = setTimeout(() => {
      setShowDescription(false);
    }, 3000);
  };

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  if (servicesWithImages.length === 0 || images.length === 0) {
    return null; // Don't show anything if no images
  }

  const currentService = servicesWithImages[currentServiceIndex];
  const currentImage = images[currentSlide];

  return (
    <div className="relative rounded-2xl overflow-hidden shadow-xl">
      {/* Main Slider Container */}
      <div className="relative h-[400px] md:h-[500px] rounded-xl overflow-hidden">
        {/* Current Image */}
        <img
          src={currentImage.url}
          alt={currentImage.description}
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
        
        {/* Service Title */}
        <div className="absolute top-6 left-6">
          <h3 className="text-xl md:text-2xl font-bold text-white drop-shadow-lg">
            {currentService.title}
          </h3>
          <p className="text-blue-200 text-sm">
            {currentService.category}
          </p>
        </div>
        
        {/* Description Overlay (Appears/Disappears) */}
        <div className={`absolute bottom-0 left-0 right-0 p-4 md:p-6 transition-all duration-500 ${
          showDescription ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          <div className="max-w-2xl mx-auto">
            <div className="inline-flex items-center mb-1 md:mb-2">
              <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                currentImage.isMain 
                  ? 'bg-blue-500 text-white' 
                  : 'bg-green-500 text-white'
              }`}>
                {currentImage.isMain ? 'Main Image' : 'Gallery Image'}
              </span>
            </div>
            <p className="text-white text-base md:text-xl font-semibold drop-shadow-lg">
              {currentImage.description}
            </p>
          </div>
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-2 md:left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 md:p-3 rounded-full transition-all hover:scale-110"
          aria-label="Previous image"
        >
          <FaChevronLeft className="h-4 w-4 md:h-6 md:w-6" />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-2 md:right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 md:p-3 rounded-full transition-all hover:scale-110"
          aria-label="Next image"
        >
          <FaChevronRight className="h-4 w-4 md:h-6 md:w-6" />
        </button>

        {/* Play/Pause Button */}
        <button
          onClick={togglePlayPause}
          className="absolute bottom-4 right-4 bg-black/50 hover:bg-black/70 text-white p-2 md:p-3 rounded-full transition-all hover:scale-110"
          aria-label={isPlaying ? "Pause slideshow" : "Play slideshow"}
        >
          {isPlaying ? (
            <FaPause className="h-4 w-4 md:h-5 md:w-5" />
          ) : (
            <FaPlay className="h-4 w-4 md:h-5 md:w-5" />
          )}
        </button>

        {/* Slide Indicator */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex items-center space-x-1 md:space-x-2">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => {
                stopAutoplay();
                setCurrentSlide(index);
                setShowDescription(true);
                if (descriptionTimeoutRef.current) clearTimeout(descriptionTimeoutRef.current);
                descriptionTimeoutRef.current = setTimeout(() => {
                  setShowDescription(false);
                }, 3000);
              }}
              className={`h-1 md:h-2 rounded-full transition-all ${
                index === currentSlide
                  ? 'w-4 md:w-8 bg-white'
                  : 'w-1 md:w-2 bg-white/50 hover:bg-white/70'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Service Selector */}
      <div className="mt-4">
        <div className="flex overflow-x-auto space-x-2 py-2 scrollbar-hide">
          {servicesWithImages.map((service, index) => (
            <button
              key={service.id}
              onClick={() => goToService(index)}
              className={`flex-shrink-0 px-3 py-2 rounded-lg text-sm transition-all whitespace-nowrap ${
                currentServiceIndex === index
                  ? 'bg-blue-600 text-white shadow'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {service.title}
            </button>
          ))}
        </div>
      </div>

      {/* View Service Button */}
      <div className="mt-4 text-center">
        <a
          href={`/services/${currentService.id}`}
          className="inline-flex items-center bg-blue-600 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg font-semibold hover:bg-blue-700 transition-all shadow"
        >
          View Full Details
          <svg className="w-4 h-4 md:w-5 md:h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </a>
      </div>
    </div>
  );
};

const Home = () => {
  const [services, setServices] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      let servicesData, projectsData;
      
      // Load services
      try {
        servicesData = await getServices();
        console.log('Services data:', servicesData);
      } catch (error) {
        console.error('Error loading services:', error);
        servicesData = [];
      }
      
      // Load projects
      try {
        projectsData = await getProjects();
        console.log('Projects data:', projectsData);
      } catch (error) {
        console.error('Error loading projects:', error);
        projectsData = [];
      }
      
      // Handle different response structures
      let servicesArray = [];
      let projectsArray = [];
      
      // Process services data
      if (Array.isArray(servicesData)) {
        servicesArray = servicesData;
      } else if (servicesData && servicesData.data && Array.isArray(servicesData.data.data)) {
        servicesArray = servicesData.data.data;
      } else if (servicesData && servicesData.data && Array.isArray(servicesData.data)) {
        servicesArray = servicesData.data;
      }
      
      // Process projects data
      if (Array.isArray(projectsData)) {
        projectsArray = projectsData;
      } else if (projectsData && projectsData.data && Array.isArray(projectsData.data.data)) {
        projectsArray = projectsData.data.data;
      } else if (projectsData && projectsData.data && Array.isArray(projectsData.data)) {
        projectsArray = projectsData.data;
      }
      
      // Filter only active services (for user-facing pages)
      const activeServices = servicesArray.filter(service => 
        service.is_active !== false
      );
      
      // Filter only active projects
      const activeProjects = projectsArray.filter(project => 
        project.is_active !== false
      );
      
      // Store all active services in sessionStorage for ServiceDetail page
      try {
        sessionStorage.setItem('allServices', JSON.stringify(activeServices));
      } catch (error) {
        console.log('Could not store services in sessionStorage:', error);
      }
      
      setServices(activeServices.slice(0, 6));
      setProjects(activeProjects.slice(0, 4));
      
    } catch (error) {
      console.error('Error loading data:', error);
      // Set empty arrays on error
      setServices([]);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
        <p className="text-gray-600">Loading content...</p>
      </div>
    );
  }

  return (
    <div>
      {/* Hero Section */}
      <HeroSection />

      {/* Services Preview */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Services</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive engineering solutions across multiple sectors
            </p>
          </div>
          
          {services.length === 0 ? (
            <div className="text-center py-12">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <p className="text-gray-500 text-lg">No services available at the moment.</p>
              <p className="text-gray-400 mt-2">Please check back later.</p>
            </div>
          ) : (
            <>
              {/* Service Image Slider */}
              <div className="mb-12">
                <ServiceImageSlider services={services} />
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {services.map(service => (
                  <ServiceCard key={service.id} service={service} />
                ))}
              </div>
              
              {services.length >= 6 && (
                <div className="text-center mt-12">
                  <a
                    href="/services"
                    className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold text-lg"
                  >
                    View All Services
                    <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </a>
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {/* Core Values */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Core Values</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              The principles that guide our work and define our company culture
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
                <FaShieldAlt className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Honesty & Integrity</h3>
              <p className="text-gray-600">
                Upholding the highest ethical standards in all our business dealings
              </p>
            </div>
            
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6">
                <FaUsers className="h-8 w-8 text-green-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Customer Service</h3>
              <p className="text-gray-600">
                Building lasting relationships through quality service and support
              </p>
            </div>
            
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-6">
                <FaAward className="h-8 w-8 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Quality</h3>
              <p className="text-gray-600">
                Delivering safe, effective products and reliable services
              </p>
            </div>
            
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-6">
                <FaHandshake className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Teamwork</h3>
              <p className="text-gray-600">
                Collaborating across disciplines to achieve excellence
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Showcase */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Recent Projects</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Showcasing our engineering expertise and successful implementations
            </p>
          </div>
          
          {projects.length === 0 ? (
            <div className="text-center py-12">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <p className="text-gray-500 text-lg">No projects to display at the moment.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {projects.map(project => (
                <ProjectCard key={project.id} project={project} />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Zambia Regulatory Authorities Section */}
      <ZambiaAuthorities />

      {/* Certifications - SIMPLIFIED VERSION */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Certifications & Compliance</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Fully compliant with all Zambian regulatory authorities and industry standards
            </p>
          </div>
          
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 border border-blue-200">
            <div className="max-w-4xl mx-auto text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-600 to-blue-800 rounded-full mb-6 shadow-lg">
                <FaCheckCircle className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                Registered & Certified in Zambia
              </h3>
              <p className="text-lg text-gray-700 mb-6">
                Brasotech Investments Limited maintains full compliance with all Zambian regulatory authorities 
                and government agencies. We operate in accordance with the highest standards of business practice 
                and legal requirements.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="/certifications" 
                  className="inline-flex items-center justify-center bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                >
                  Learn About Our Compliance
                </a>
                <a 
                  href="/contact" 
                  className="inline-flex items-center justify-center bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold border border-blue-600 hover:bg-blue-50 transition-colors"
                >
                  Request Verification
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 py-20">
        <div className="container-custom text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Contact us today for a consultation and let's build something great together.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200"
            >
              Get In Touch
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </a>
            <a
              href="/services"
              className="inline-flex items-center justify-center bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors duration-200"
            >
              View Our Services
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;